import { SelectTabData, Tab, TabList } from "@fluentui/react-components";
import _ from "lodash";

import { memo, useCallback } from "react";
import ArticleIcon from "~icons/material-symbols/article";
import ArticleOutlineIcon from "~icons/material-symbols/article-outline";
import CommentIcon from "~icons/material-symbols/comment";
import CommentOutlineIcon from "~icons/material-symbols/comment-outline";
import ListAltIcon from "~icons/material-symbols/list-alt";
import ListAltOutlineIcon from "~icons/material-symbols/list-alt-outline";
import { bundleIcon } from "../../../components/icons";
import { ClauseTab } from "../../../types/enums/clauseTabs";
import { useSelectableTabListStyles } from "../styles/SelectableTabList.styles";

type SelectableTabListProps = {
  value: string;
  onChange: (tab: string) => void;
};

const DocumentInfoIcon = bundleIcon(ArticleIcon, ArticleOutlineIcon);
const SimilarClauseIcon = bundleIcon(ListAltIcon, ListAltOutlineIcon);
const CommentsIcon = bundleIcon(CommentIcon, CommentOutlineIcon);

export const SelectableTabList = memo(({ value, onChange }: SelectableTabListProps) => {
  const styles = useSelectableTabListStyles();

  const onSelectedTabChange = useCallback(
    _.debounce((_ev, data: SelectTabData) => {
      onChange(data.value as string);
    }, 300),
    [onChange]
  );

  return (
    <TabList
      className={styles.stretchedTabs}
      defaultSelectedValue={ClauseTab.DOCUMENT_INFO}
      selectedValue={value}
      onTabSelect={onSelectedTabChange}
    >
      <Tab id={ClauseTab.DOCUMENT_INFO} icon={<DocumentInfoIcon />} value={ClauseTab.DOCUMENT_INFO}>
        More Info
      </Tab>
      <Tab id={ClauseTab.SIMILAR_CLAUSES} icon={<SimilarClauseIcon />} value={ClauseTab.SIMILAR_CLAUSES}>
        Similar Clauses
      </Tab>
      <Tab id={ClauseTab.COMMENTS} icon={<CommentsIcon />} value={ClauseTab.COMMENTS}>
        Comments
      </Tab>
    </TabList>
  );
});
